<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      :finish-button-text="$can('create','pengajuan-sidang') ? 'Ajukan' : 'Simpan'"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Form Pendaftaran"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Form Pendaftaran Ujian
              </h5>
              <small class="text-muted">
                Lengkapi form pendaftaran anda.
              </small>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group>
                <label for="">Jenjang <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jenjang"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="jenjang"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jenjangOption.options"
                    v-model="berkas.jenjang_id"
                    placeholder="Pilih Jenjang"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Prodi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="prodi"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prodiOption.options"
                    v-model="berkas.prodi_id"
                    placeholder="Pilih prodi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- //DATA SKRIPSI S1 MUNCUL KETIKA PILIH JENJANG -->
          <b-row v-if="berkas.jenjang_id == 'd7502c8f68d11921bdf217e8fd173a69'">
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Lengkap <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="name"
                    v-model="berkas.name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Lengkap"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Ijazah <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nama_ijazah"
                    v-model="berkas.nama_ijazah"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Ijazah"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <!-- <b-col md="6">
              <b-form-group>
                <label for="">Asal SMA <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="asal_sma"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="asal_sma"
                    v-model="berkas.asal_sma"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Asal SMA"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Jurusan SMA <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jurusan_sma"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jurusanSMAOption.options"
                    v-model="berkas.jurusan_sma"
                    placeholder="Pilih Jurusan SMA"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="6">
              <b-form-group>
                <label for="">NPM <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="npm"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="npm"
                    v-model="berkas.npm"
                    :state="errors.length > 0 ? false:null"
                    placeholder="NPM"
                    :maxlength="10"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Angkatan <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="angkatan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="angkatan"
                    v-model="berkas.angkatan"
                    :state="errors.length > 0 ? false:null"
                    placeholder="2023"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tempat Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tempat_lahir"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="tempat_lahir"
                    v-model="berkas.tempat_lahir"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Tempat Lahir"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tanggal Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_lahir"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-datepicker v-model="berkas.tanggal_lahir" locale="id"></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Mahasiswa <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Alamat Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat_orang_tua"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Pekerjaan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="pekerjaan_orang_tua"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="pekerjaan_orang_tua"
                    v-model="berkas.pekerjaan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Pekerjaan Orang Tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Jabatan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jabatan_orang_tua"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jabatan_orang_tua"
                    v-model="berkas.jabatan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jabatan Orang Tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor Telp <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_telp"
                >
                  <b-form-input
                    id="nomor_telp"
                    v-model="berkas.nomor_telp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Telpon Rumah"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor HP <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_hp"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nomor_hp"
                    v-model="berkas.nomor_hp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor HP"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email UI <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email Selain UI <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_selain_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- //DATA SKRIPSI S2 MUNCUL KETIKA PILIH JENJANG -->
          <b-row v-if="berkas.jenjang_id == '4c9a8f414b8fcbab8c8a993d182ef72b'">
            <b-col md="6">
              <b-form-group>
                <label for="">Nama <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="name"
                    v-model="berkas.name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Lengkap"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Nama Ijazah <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nama_ijazah"
                    v-model="berkas.nama_ijazah"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Ijazah"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
             <!-- <b-col md="6">
              <b-form-group>
                <label for="">Asal SMA <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="asal_sma"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="asal_sma"
                    v-model="berkas.asal_sma"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Asal SMA"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Jurusan SMA <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jurusan_sma"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jurusanSMAOption.options"
                    v-model="berkas.jurusan_sma"
                    placeholder="Pilih Jurusan SMA"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="6">
              <b-form-group>
                <label for="">NPM <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="npm"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="npm"
                    v-model="berkas.npm"
                    :state="errors.length > 0 ? false:null"
                    placeholder="NPM"
                    :maxlength="10"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Peminatan <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="peminatan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="peminatanOption.options"
                    v-model="berkas.peminatan_id"
                    placeholder="Pilih Peminatan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Semester <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="semester"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="semester"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="semesterOption.options"
                    v-model="berkas.semester_id"
                    placeholder="Pilih Semester"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- //DATA SKRIPSI S2 MUNCUL KETIKA PILIH JENJANG -->
          <b-row v-if="berkas.jenjang_id == '4c9a8f414b8fcbab8c8a993d182ef72b'">
             <b-col md="3">
              <b-form-group>
                <label for="">Tahun Akademik <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tahun_akademik"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="tahun_akademik"
                    v-model="berkas.tahun_akademik_from"
                    :state="errors.length > 0 ? false:null"
                    placeholder="2022"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <label for="" class="mt-3">/</label>
            <b-col md="3">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="tahun_akademik"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="tahun_akademik"
                    v-model="berkas.tahun_akademik_to"
                    :state="errors.length > 0 ? false:null"
                    placeholder="2023"
                    type="number"
                    style="margin-top: 28px;"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5">
             <b-form-group>
               <label for="">Jumlah SKS diperoleh<span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_diperoleh"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jumlah_sks_diperoleh"
                    v-model="berkas.jumlah_sks_diperoleh"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jumlah SKS diperoleh"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id == '4c9a8f414b8fcbab8c8a993d182ef72b'">
           
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Angkatan <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="angkatan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="angkatan"
                    v-model="berkas.angkatan"
                    :state="errors.length > 0 ? false:null"
                    placeholder="2023"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Tempat Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tempat_lahir"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="tempat_lahir"
                    v-model="berkas.tempat_lahir"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Tempat Lahir"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Tanggal Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_lahir"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-datepicker v-model="berkas.tanggal_lahir" locale="id"></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Alamat Mahasiswa <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
             <!-- <b-col md="6">
              <b-form-group>
                <label for="">Alamat Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat_orang_tua"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Pekerjaan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="pekerjaan_orang_tua"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="pekerjaan_orang_tua"
                    v-model="berkas.pekerjaan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Pekerjaan Orang Tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Jabatan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jabatan_orang_tua"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jabatan_orang_tua"
                    v-model="berkas.jabatan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jabatan Orang Tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor Telp <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_telp"
                >
                  <b-form-input
                    id="nomor_telp"
                    v-model="berkas.nomor_telp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Telpon Rumah"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor HP <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_hp"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nomor_hp"
                    v-model="berkas.nomor_hp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor HP"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email UI <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_selain_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
           <!-- //DATA SKRIPSI S2 MUNCUL KETIKA PILIH JENJANG -->
          <b-row v-if="berkas.jenjang_id == '4c9a8f414b8fcbab8c8a993d182ef72b'" class="mt-2">
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Ayah <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama_ayah"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nama_ayah"
                    v-model="berkas.nama_ayah"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Ayah"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Ibu <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama_ibu"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nama_ibu"
                    v-model="berkas.nama_ibu"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Ibu"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat_orang_tua"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor Telp <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_telp"
                >
                  <b-form-input
                    id="nomor_telp"
                    v-model="berkas.nomor_telp_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Telpon Rumah"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor HP <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_hp"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nomor_hp"
                    v-model="berkas.nomor_hp_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor HP"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Pekerjaan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="pekerjaan_orang_tua"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="pekerjaan_orang_tua"
                    v-model="berkas.pekerjaan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Pekerjaan Orang Tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Jabatan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jabatan_orang_tua"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jabatan_orang_tua"
                    v-model="berkas.jabatan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jabatan Orang Tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Instansi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama_instansi"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="nama_instansi"
                    v-model="berkas.nama_instansi"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Instansi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="berkas.jenjang_id != null">
           <b-col md="6">
              <b-form-group>
                <label for="">Judul <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="judul"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="judul"
                    v-model="berkas.judul"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Judul"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Penelitian Payung <span style="color: blue;">(Opsional)</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="penelitian_payung"
                >
                  <b-form-input
                    id="penelitian_payung"
                    v-model="berkas.penelitian_payung"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Penilitian Payung"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="berkas.jenjang_id != null">
            <b-row>
              <b-col md="12">
                  <div class="d-flex justify-content-end" style="margin-bottom: 20px; margin-top: 20px;">
                    <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinner == 1"
                  ></b-spinner>
                    <b-button v-if="berkas.jenjang_id == '9221e9f05c40488a60128e9ced01aa1a'" @click="tambahWaktuUjian()" variant="outline-primary" style="margin-right: 10px;"><feather-icon icon="PlusIcon" /> Tambah Waktu Ujian
                    </b-button>
                  </div>
              </b-col>
            </b-row>
            <b-row  v-for="item in berkas.waktu_ujian" :key="item.id" class="mb-2">
              <b-col md="6">
                <b-form-group>
                  <label for="">Usulan Tanggal Ujian <span style="color: red; font-size: 16px;">*</span></label>
                  <validation-provider
                    #default="{ errors }"
                    name="tanggal_sidang"
                    rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                  >
                    <b-form-datepicker v-model="item.tanggal_ujian" locale="id"></b-form-datepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
                <b-col md="5">
                  <b-form-group>
                    <label for="">Usulan Waktu Ujian <span style="color: red; font-size: 16px;">*</span></label>
                    <validation-provider
                      #default="{ errors }"
                      name="waktu_ujian"
                      rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                    >
                    <v-select
                      id="waktu_ujian_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :reduce="val => val.value"
                      :options="waktuUjianOption.options"
                      v-model="item.waktu_ujian_id"
                      placeholder="Pilih Waktu"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="1">
                  <b-button @click="deleteWaktuUjian(item.uuid)" variant="outline-danger" style="margin-top:27px;"><feather-icon icon="TrashIcon" /></b-button>
              </b-col>
            </b-row>  
          </div>
          <b-row v-if="berkas.jenjang_id != null">
            <b-col md="6">
              <b-form-group>
               <label for="">Skema Ujian <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="skema_ujian"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="skema_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prosesPersidanganOption.options"
                    v-model="berkas.skema_ujian_id"
                    placeholder="Pilih Skema Ujian"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
              <b-col md="12">
                  <div class="d-flex justify-content-end" style="margin-top: 20px;">
                    <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinnerPembimbing == 1"
                  ></b-spinner>
                    <b-button @click="tambahPembimbing()" variant="outline-primary" style="margin-bottom: 10px; margin-right: 10px;"><feather-icon icon="PlusIcon" /> Tambah Pembimbing
                    </b-button>
                  </div>
              </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null" v-for="(item, index) in berkas.dosen_pembimbing" :key="item.id" style="margin-bottom: 20px;">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing {{ index += 1 }} <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="item.dosen_pembimbing_id"
                    placeholder="Pilih Dosen Pembimbing"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="5">
             <b-form-group>
                <label for="">Alamat Email Pembimbing {{ index }} <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="item.email"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="$can('set-pembimbing-utama','pengajuan-sidang')">
              <b-form-group>
                <label for="">Pembimbing Utama ?<span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Pembimbing Utama"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenUtamaOption.options"
                    v-model="item.pembimbing_utama"
                    placeholder="Pilih"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="1">
              <div class="d-flex justify-content-begin">
                <b-button @click="deletePembimbing(item.uuid)" variant="outline-danger" style="margin-top:27px; margin-right: 10px;"><feather-icon icon="TrashIcon" /></b-button>
              </div>  
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing 2 <span style="color: blue;">(Opsional)</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_pembimbing_2_id"
                    placeholder="Pilih Dosen Pembimbing"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
                <label for="">Alamat Email Pembimbing 2 <span style="color: blue;">(Opsional)</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_pembimbing_2"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing Akademik <span style="color: red;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing Akademik"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_pembimbing_akademik_id"
                    placeholder="Pilih Dosen Pembimbing Akademik"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing Skripsi Magang <span style="color: blue;">(Opsional)</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing Magang"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_pembimbing_magang_id"
                    placeholder="Pilih Dosen Pembimbing Magang"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
              <b-col md="12">
                  <div class="d-flex justify-content-end" style="margin-top: 20px;">
                    <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinnerPenguji == 1"
                  ></b-spinner>
                    <b-button v-if="berkas.jenjang_id == '9221e9f05c40488a60128e9ced01aa1a'" @click="tambahPenguji()" variant="outline-primary" style="margin-right: 10px;"><feather-icon icon="PlusIcon" /> Tambah Penguji
                    </b-button>
                  </div>
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="berkas.jenjang_id != null" v-for="(item, index) in berkas.dosen_penguji" :key="item.id" style="margin-bottom: 20px;">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Penguji {{ index += 1 }} <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_penguji_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="item.dosen_penguji_id"
                    placeholder="Pilih Dosen Penguji"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="">Apakah Penguji {{ index }} sudah setuju untuk menguji skripsi Anda? <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jawabanPersetujuanOption.options"
                    v-model="item.jawaban_persetujuan_id"
                    placeholder="Pilih Jawaban"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="$can('set-penguji-utama','pengajuan-sidang')">
              <b-form-group>
                <label for="">Penguji Utama ?<span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_penguji"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenUtamaOption.options"
                    v-model="item.penguji_utama"
                    placeholder="Pilih"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="1">
              <div class="d-flex justify-content-begin">
                <b-button @click="deletePenguji(item.uuid)" variant="outline-danger" style="margin-top:27px; margin-right: 10px;"><feather-icon icon="TrashIcon" /></b-button>
              </div>  
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Dosen Penguji 2 <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_penguji_2_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_penguji_2_id"
                    placeholder="Pilih Dosen Penguji 2"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Apakah Penguji 1 sudah setuju untuk menguji skripsi Anda? <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jawabanPersetujuanOption.options"
                    v-model="berkas.jawaban_dosen_penguji_2_id"
                    placeholder="Pilih Jawaban"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row class="mt-3" v-if="berkas.jenjang_id == 'd7502c8f68d11921bdf217e8fd173a69'">
            <b-col md="6">
              <b-form-group>
                <label for="">Awal Bimbingan Skripsi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="awal_bimbingan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-datepicker v-model="berkas.awal_bimbingan"  locale="id"></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Akhir Bimbingan Skripsi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="akhir_bimbingan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-datepicker v-model="berkas.akhir_bimbingan"  locale="id"></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">Semester yang dijalani saat ini <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="semester_saat_ini"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="semester_saat_ini"
                    v-model="berkas.semester_saat_ini"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Semester yang dijalani saat ini"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">Lama Bimbingan Skripsi (Dalam Bulan) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="lama_bimbingan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="lama_bimbingan"
                    v-model="berkas.lama_bimbingan"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Dalam Bulan"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
               <label for="">Jumlah SKS diperoleh (Acuan SIAK NG) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_diperoleh"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jumlah_sks_diperoleh"
                    v-model="berkas.jumlah_sks_diperoleh"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Acuan SIAK NG"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group
              title="Untuk Melihat Total SKS Lulus, Silahkan cek pada SIAK NG."
             >
                <label for="">
                  Total SKS Lulus
                  <span style="color: red; font-size: 16px;">* </span>
                  <feather-icon icon="InfoIcon"/>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="keterangan_kekurangan_sks"
                >
                  <b-form-input
                    id="keterangan_kekurangan_sks"
                    v-model="berkas.keterangan_kekurangan_sks"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Total SKS Lulus"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group
              title="Untuk Melihat Total Mutu yang diperoleh, Silahkan cek pada SIAK NG."
             >
              <label for="">Total Mutu diperoleh <span style="color: red; font-size: 16px;">* </span><feather-icon icon="InfoIcon"/></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_mutu_diperoleh"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jumlah_mutu_diperoleh"
                    v-model="berkas.jumlah_mutu_diperoleh"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Acuan SIAK NG"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">Jumlah SKS Semester ini yang sedang diambil <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_semester_ini"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="jumlah_sks_semester_ini"
                    v-model="berkas.jumlah_sks_semester_ini"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jumlah SKS Semester ini"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">IPK (Sebelum Ujian Skripsi) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="ipk_sebelum_ujian"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="ipk_sebelum_ujian"
                    v-model="berkas.ipk_sebelum_ujian"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Acuan SIAK NG"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        title="Berkas Sidang"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Sidang
              </h5>
              <small class="text-muted">Lengkapi Berkas Sidang Anda</small>
            </b-col>
          </b-row>
          <!-- Berkas Sidang -->
          <b-row v-for="item in berkas.berkas_pengajuan" :key="item.berkas_pengajuan_uuid" style="margin-bottom: 10px;">
            <b-col md="6">
              <b-form-group>
                <label for="">{{ item.title }} <span style="color: red; font-size: 16px;" v-if="item.is_required">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  :name="item.title"
                  :rules="item.is_required == 1 && item.file == null ? 'required' : ''"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="item.file_input"
                    accept="application/pdf"
                  />
                  <b-button
                    v-if="item.file != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(item.file)"
                  >
                    Lihat
                  </b-button>
                  <div>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :variant="$can('set-note-berkas', 'pengajuan-sidang') ? 'outline-primary' : 'danger'"
                      class="mb-75 mr-75 ml-1"
                      @click="$bvModal.show(`bv-modal-note${item.berkas_pengajuan_uuid}`)"
                      v-if="item.note != null"
                    >
                      Catatan
                    </b-button>
                    <b-modal :id="`bv-modal-note${item.berkas_pengajuan_uuid}`" hide-footer>
                      <template #modal-title>
                        Catatan Perbaikan Berkas
                      </template>
                      <div class="d-block text-center">
                        <b-form-textarea rows="5" placeholder="Catatan Perbaikan" v-model="item.note"></b-form-textarea>
                      </div>
                      <center>
                        <b-button class="mt-3" variant="danger" @click="$bvModal.hide(`bv-modal-note${item.berkas_pengajuan_uuid}`)">Tutup</b-button>
                      </center>>
                    </b-modal>
                  </div>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
               <label for="">{{ item.description }}</label>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Konfirmasi"
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row style="text-align: center;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Konfirmasi untuk mengajukan berkas ujian?
              </h5>
              <h5 class="mb-0">
                Pastikan dan cek kembali data anda sebelum mengajukan berkas ujian.
              </h5>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="6">
              <b-form-group
                label="Berkas Presentasi (pptx)"
                label-for="Berkas Presentasi (pptx)"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Berkas Presentasi (pptx)"
                >
                  
                  <div class="d-flex">
                    <b-form-file
                    ref="file-input"
                    v-model="berkas.file_presentasi"
                    accept="application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                  />
                    <b-button
                    v-if="berkas.file_berkas_presentasi != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="downloadFile(berkas.file_berkas_presentasi)"
                  >
                    Lihat
                  </b-button>
                  </div>
                  
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row> -->
          <!-- <b-row>
            <b-col md="6">
              <b-form-group
                label="Link Video Presentasi"
                label-for="Link Video Presentasi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="link_video"
                >
                  <b-form-input
                    id="link_video"
                    v-model="berkas.link_video_presentasi"
                    :state="errors.length > 0 ? false:null"
                    placeholder="https://youtube.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row> -->
        </validation-observer>
      </tab-content>

      <tab-content
        v-if="berkas.role != 'mahasiswa'"
        title="Ruangan Sidang"
        :before-change="validationFormAddress2"
      >
        <validation-observer
          ref="addressRules2"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ruangan Sidang
              </h5>
              <small class="text-muted">Lengkapi ruangan sidang</small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Ruangan Sidang"
                label-for="Ruangan Sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ruangan_sidang"
                >
                  <v-select
                    id="ruangan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="ruanganOption.options"
                    v-model="berkas.ruangan_id"
                    placeholder="Pilih Ruangan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Link Zoom"
                label-for="Link Zoom"
              >
                <validation-provider
                  #default="{ errors }"
                  name="link_zoom"
                >
                 <b-form-input
                    id="link_zoom"
                    v-model="berkas.link_zoom"
                    :state="errors.length > 0 ? false:null"
                    placeholder="https://zoom.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div v-if="this.error_check.length == 0">
            <div class="d-flex justify-content-center mt-2">
              <b-spinner
              :variant="'dark'"
              ></b-spinner>
            </div>
            <div class="d-flex justify-content-center mt-2">
            Loading....
            </div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-center mt-2">
              <h4 style="color:red;">Gagal Memuat Data</h4>
            </div>
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import JadwalSidangDosen from '@/views/pages/jadwal-sidang-dosen/list/List.vue'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCalendar,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BFormTextarea,
  BModal,
  BSpinner,
  BTooltip,
  BTable,
} from 'bootstrap-vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { codeIcon } from './code'
import {
  getUserDetail,
  getJurusan,
  getJenjang,
  getProdi,
  getPeminatan,
  getJenisSidang,
  getProsesPersidangan,
  getDosen,
  postBerkas,
  updateBerkas,
  getPengajuanSidangDetail,
  uploadFilePengajuan,
  downloadDokumen,
  getRuangan,
  getProgram,
  getWaktuUjian,
  getJawabanPersetujuan,
  postWaktuUjian,
  deleteWaktuUjian,
  postPembimbing,
  deletePembimbing,
  postPenguji,
  deletePenguji,
} from '@/connection-api/master'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    BButton,
    BCalendar,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BFormTextarea,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BModal,
    BSpinner,
    BTooltip,
    BTable,
    JadwalSidangDosen,
  },
  directives: {
    Ripple,
  },
  data() {
      // 15th two months prior
      const minDate = new Date('2023-06-12')
      minDate.setDate(minDate.getDate())
      // 15th in two months
      const maxDate = new Date('2023-07-12')
      maxDate.setDate(maxDate.getDate())

    return {
      params_jadwal_dosen: {},
      jadwalDosen: [
          { nama_dosen: 'Dickerson', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' },
          { nama_dosen: 'Larsen', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' },
          { nama_dosen: 'Geneva', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' },
          { nama_dosen: 'Jami', tanggal: '23-01-2023', waktu: 'Pukul 18.00 - 20.00' }
      ],
      showSpinner: 0,
      showSpinnerPembimbing: 0,
      showSpinnerPenguji: 0,
      success_check: [],
      error_check: [],
      tahunOptions: [],
      showModal: 1,
      file: {
        file_persetujuan_pembimbing: null,
        file_ringkasan_turnitin: null,
        file_riwayat_pembayaran_bop: null,
        file_berkas_lengkap_skripsi: null,
        file_screenshoot_siak_ng: null,
      },
      minTime: '08:00',
      maxTime: '16:00',
      min: minDate,
      max: maxDate,
      selectedContry: '',
      selectedLanguage: '',
      userData: {},
      berkas: {},
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
       programOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Program --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Peminatan --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Sidang --' },
        ],
      },
      prosesPersidanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Skema Ujian --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      dosenUtamaOption: {
        selected: 'id',
        options: [
          { value: null, title: 'Pilih' },
          { value: 'ya', title: 'Ya' },
          { value: "tidak", title: 'Tidak' },
        ],
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu --' },
        ],
      },
      jawabanPersetujuanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jawaban --' },
        ],
      },
      jurusanSMAOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan SMA --' },
          { value: 'IPA', title: 'IPA' },
          { value: 'IPS', title: 'IPS' },
          { value: 'Lainnya', title: 'Lainnya' },
        ],
      },
      semesterOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Semester --' },
          { value: 'Ganjil', title: 'Ganjil' },
          { value: 'Genap', title: 'Genap' },
        ],
      },
    }
  },
  mounted() {
      this.populateYearOptions();
      this.$bvModal.show('modal-center-loading')
      if(!this.$route.params.uuid){
          postBerkas()
          .then(response => {
            if (response.data.success == true) {
              success_check.push('success')
              this.completeCheck()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Sidang',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Redirecting ...',
                },
              })
              setTimeout(() => {
                this.$router.push({ 
                  name: 'pengajuan-sidang-edit', 
                  params: { uuid: response.data.data.uuid } 
                })
              }, 1000);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Sidang',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
                duration: 5000,
              })
            }
          })
          .catch(error => console.log(error));
        } else {
          this.reloadData()
        }

       
  },
  methods: {
    reloadData() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas = response.data.data;
              this.success_check.push('success')
              this.completeCheck()
              if(this.berkas.status_pengajuan_sidang_id == '2dcb20fca8d7dabd6' || this.berkas.status_pengajuan_sidang_id == 'ae7ebb35d51267ce' || this.berkas.status_pengajuan_sidang_id == 'd790e33d3590f10799')
              {
                this.$router.push({name: 'list-sidang'})
              }
              
              if(this.berkas.jawaban.length > 0)
              {
                this.buildOption(this.berkas.jawaban, this.jawabanPersetujuanOption)
              }

              if(this.berkas.ruangan.length > 0)
              {
                this.buildOption(this.berkas.ruangan, this.ruanganOption)
              }

              if(this.berkas.dosen.length > 0)
              {
                this.buildOption(this.berkas.dosen, this.dosenOption)
              }

              if(this.berkas.waktu.length > 0)
              {
                this.buildOption(this.berkas.waktu, this.waktuUjianOption)
              }

              if(this.berkas.jurusan.length > 0)
              {
                this.buildOption(this.berkas.jurusan, this.jurusanOption)
              }

              if(this.berkas.proses_persidangan.length > 0)
              {
                this.buildOption(this.berkas.proses_persidangan, this.prosesPersidanganOption)
              }

              if(this.berkas.jenis_sidang.length > 0)
              {
                this.buildOption(this.berkas.jenis_sidang, this.jenisSidangOption)
              }

              // if(this.berkas.program.length > 0)
              // {
              //   this.buildOption(this.berkas.program, this.programOption)
              // }

              if(this.berkas.jenjang.length > 0)
              {
                this.buildOption(this.berkas.jenjang, this.jenjangOption)
              }

              if(this.berkas.prodi.length > 0)
              {
                this.buildOption(this.berkas.prodi, this.prodiOption)
              }

              if(this.berkas.peminatan.length > 0)
              {
                this.buildOption(this.berkas.peminatan, this.peminatanOption)
              }
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    reloadDataWaktuUjian() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas.waktu_ujian = response.data.data.waktu_ujian;
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    reloadDataPembimbing() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas.dosen_pembimbing = response.data.data.dosen_pembimbing;
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    reloadDataPenguji() {
      getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas.dosen_penguji = response.data.data.dosen_penguji;
            })
          .catch(error => {
            this.error_check.push(error)
          });
    },
    async tambahWaktuUjian() {
      this.showSpinner = 1
      var data = {
        uuid: this.$route.params.uuid,
        waktu_ujian: this.berkas.waktu_ujian,
        jenjang_id: this.berkas.jenjang_id,
      }
      await postWaktuUjian(data)
            .then(response => {
              if (response.data.success == true) {
                this.reloadDataWaktuUjian()
                this.showSpinner = 0
              } else {
                this.showSpinner = 0
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
    },
    async deleteWaktuUjian(uuid) {
      this.showSpinner = 1
      var data = {
        pengajuan_sidang_uuid: this.$route.params.uuid,
        uuid: uuid,
      }
      await deleteWaktuUjian(data)
        .then(response => {
          if (response.data.success == true) {
            this.reloadDataWaktuUjian()
            this.showSpinner = 0
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
    },
    async tambahPembimbing() {
      this.showSpinnerPembimbing = 1
      var data = {
        uuid: this.$route.params.uuid,
        jenjang_id: this.berkas.jenjang_id,
        dosen_pembimbing: this.berkas.dosen_pembimbing,
      }
      await postPembimbing(data)
            .then(response => {
              if (response.data.success == true) {
                this.reloadDataPembimbing()
                this.showSpinnerPembimbing = 0
              } else {
                this.showSpinnerPembimbing = 0
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
    },
    async deletePembimbing(uuid) {
      this.showSpinnerPembimbing = 1
      var data = {
        pengajuan_sidang_uuid: this.$route.params.uuid,
        uuid: uuid,
      }
      await deletePembimbing(data)
        .then(response => {
          if (response.data.success == true) {
            this.reloadDataPembimbing()
            this.showSpinnerPembimbing = 0
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
    },
    async tambahPenguji() {
      this.showSpinnerPenguji = 1
      var data = {
        uuid: this.$route.params.uuid,
        jenjang_id: this.berkas.jenjang_id,
        dosen_penguji: this.berkas.dosen_penguji,
      }
      await postPenguji(data)
            .then(response => {
              if (response.data.success == true) {
                this.reloadDataPenguji()
                this.showSpinnerPenguji = 0
              } else {
                this.showSpinnerPenguji = 0
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
    },
    async deletePenguji(uuid) {
      this.showSpinnerPenguji = 1
      var data = {
        pengajuan_sidang_uuid: this.$route.params.uuid,
        uuid: uuid,
      }
      await deletePenguji(data)
        .then(response => {
          if (response.data.success == true) {
            this.reloadDataPenguji()
            this.showSpinnerPenguji = 0
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
    },
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    populateYearOptions() {
      const currentYear = new Date().getFullYear();
      const yearsToShow = 30; // Adjust this number as needed to show more or fewer years

      for (let i = currentYear; i >= currentYear - yearsToShow; i--) {
        this.tahunOptions.push({ value: i, title: i.toString() });
      }
    },
    completeCheck()
    {
      if(this.success_check.length > 0 && this.error_check.length == 0)
      {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    async downloadFile(file){
      const result = await downloadDokumen(file);
      const blob = new Blob([result.data], {type: 'application/vnd.ms-powerpoint'});
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      const date = new Date().toLocaleString(['ban', 'id']);
      const filename = `berkas-${date}.pptx`.replace(/[^a-z0-9_.-]/gi, '_'); // replaces invalid characters
      link.download = filename;
      link.href = url;

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url)
    },
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadDokumen(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pengajuan Sidang',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      // return weekday === 0 || weekday === 6 || day === 14
        return weekday === 0
    },
    formSubmitted() {
      if(window.confirm('Apakah anda yakin ingin mengajukan berkas sidang ini?'))
      {
        this.$bvModal.show('modal-center-loading')
        this.showModal = 1
         this.berkas.flag = 'Konfirmasi'
          uploadFilePengajuan(this.berkas.file_presentasi, 'user', event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          })
            .then(response => {
              this.berkas.berkas_presentasi = response.data.data;

              updateBerkas(this.berkas)
              .then(response => {
                if (response.data.success == true) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Pengajuan Sidang',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan',
                    },
                    duration: 5000,
                  })
                  this.showModal = 0
                  if(this.berkas.role == 'mahasiswa')
                  {
                     setTimeout(() => {
                      this.$router.push({name: 'list-sidang'})
                    }, 3000);
                  }
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Pengajuan Sidang',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan',
                    },
                  })
                  this.showModal = 0
                }
              })
              .catch(error => {
                this.showModal = 0
              });
            })
          .catch(error => {
            this.showModal = 0
          });
      }
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            this.berkas.flag = 'Biodata'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                this.berkas.berkas_pengajuan = response.data.data
                resolve(true)
              } else {
                reject()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => console.log(error));
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            this.berkas.berkas_pengajuan.forEach(function(value, index, data) {
              // Code to execute for each element in the array
              if(data[index].file_input != null)
              {
                uploadFilePengajuan(data[index].file_input, 'user', event => {
                var progress = Math.round((100 * event.loaded) / event.total)
              })
                .then(response0 => {
                  data[index].file = response0.data.data
                  data[index].flag = 'Berkas Sidang'
                  updateBerkas(data[index])
                  .then(response => {
                    if (response.data.success == true) {
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Pengajuan Sidang',
                          icon: 'EditIcon',
                          variant: 'danger',
                          text: response.data.message,
                        },
                      })
                    }
                  })
                  .catch(error => console.log(error));
                })
              .catch(error => console.log(error));
              }
            });
            

            // if(this.file.file_persetujuan_pembimbing != null)
            // {
            //   uploadFilePengajuan(this.file.file_persetujuan_pembimbing, 'user', event => {
            //   this.progress = Math.round((100 * event.loaded) / event.total)
            // })
            //   .then(response1 => {
            //     this.berkas.lembar_persetujuan_pembimbing = response1.data.data;

            //     updateBerkas(this.berkas)
            //     .then(response => {
            //       if (response.data.success == true) {
            //         // this.$toast({
            //         //   component: ToastificationContent,
            //         //   props: {
            //         //     title: 'Pengajuan Sidang',
            //         //     icon: 'EditIcon',
            //         //     variant: 'success',
            //         //     text: 'Data berhasil disimpan',
            //         //   },
            //         //   duration: 5000,
            //         // })
            //       } else {
            //         this.$toast({
            //           component: ToastificationContent,
            //           props: {
            //             title: 'Pengajuan Sidang',
            //             icon: 'EditIcon',
            //             variant: 'danger',
            //             text: response.data.message,
            //           },
            //         })
            //       }
            //     })
            //     .catch(error => console.log(error));
            //   })
            // .catch(error => console.log(error));
            // }
            
            // if(this.file.file_ringkasan_turnitin != null)
            // {
            //   uploadFilePengajuan(this.file.file_ringkasan_turnitin, 'user', event => {
            //   this.progress = Math.round((100 * event.loaded) / event.total)
            // })
            //   .then(response2 => {
            //     this.berkas.lembar_ringkasan_turnitin = response2.data.data;

            //     updateBerkas(this.berkas)
            //     .then(response => {
            //       if (response.data.success == true) {
            //         // this.$toast({
            //         //   component: ToastificationContent,
            //         //   props: {
            //         //     title: 'Pengajuan Sidang',
            //         //     icon: 'EditIcon',
            //         //     variant: 'success',
            //         //     text: 'Data berhasil disimpan',
            //         //   },
            //         //   duration: 5000,
            //         // })
            //       } else {
            //         this.$toast({
            //           component: ToastificationContent,
            //           props: {
            //             title: 'Pengajuan Sidang',
            //             icon: 'EditIcon',
            //             variant: 'danger',
            //             text: response.data.message,
            //           },
            //         })
            //       }
            //     })
            //     .catch(error => console.log(error));
            //   })
            // .catch(error => console.log(error));
            // }
            
            // if(this.file.file_berkas_lengkap_skripsi)
            // {
            //   uploadFilePengajuan(this.file.file_berkas_lengkap_skripsi, 'user', event => {
            //   this.progress = Math.round((100 * event.loaded) / event.total)
            // })
            //   .then(response3 => {
            //     this.berkas.lembar_berkas_lengkap_skripsi = response3.data.data;

            //     updateBerkas(this.berkas)
            //     .then(response => {
            //       if (response.data.success == true) {
            //         // this.$toast({
            //         //   component: ToastificationContent,
            //         //   props: {
            //         //     title: 'Pengajuan Sidang',
            //         //     icon: 'EditIcon',
            //         //     variant: 'success',
            //         //     text: 'Data berhasil disimpan',
            //         //   },
            //         //   duration: 5000,
            //         // })
            //       } else {
            //         this.$toast({
            //           component: ToastificationContent,
            //           props: {
            //             title: 'Pengajuan Sidang',
            //             icon: 'EditIcon',
            //             variant: 'danger',
            //             text: response.data.message,
            //           },
            //         })
            //       }
            //     })
            //     .catch(error => console.log(error));
            //   })
            // .catch(error => console.log(error));
            // }

            // if(this.file.file_riwayat_pembayaran_bop)
            // {
            //   uploadFilePengajuan(this.file.file_riwayat_pembayaran_bop, 'user', event => {
            //   this.progress = Math.round((100 * event.loaded) / event.total)
            // })
            //   .then(response4 => {
            //     this.berkas.lembar_riwayat_pembayaran_bop = response4.data.data;

            //     updateBerkas(this.berkas)
            //     .then(response => {
            //       if (response.data.success == true) {
            //         // this.$toast({
            //         //   component: ToastificationContent,
            //         //   props: {
            //         //     title: 'Pengajuan Sidang',
            //         //     icon: 'EditIcon',
            //         //     variant: 'success',
            //         //     text: 'Data berhasil disimpan',
            //         //   },
            //         //   duration: 5000,
            //         // })
            //       } else {
            //         this.$toast({
            //           component: ToastificationContent,
            //           props: {
            //             title: 'Pengajuan Sidang',
            //             icon: 'EditIcon',
            //             variant: 'danger',
            //             text: response.data.message,
            //           },
            //         })
            //       }
            //     })
            //     .catch(error => console.log(error));
            //   })
            // .catch(error => console.log(error));
            // }

            // if(this.file.file_screenshoot_siak_ng)
            // {
            //   uploadFilePengajuan(this.file.file_screenshoot_siak_ng, 'user', event => {
            //   this.progress = Math.round((100 * event.loaded) / event.total)
            // })
            //   .then(response5 => {
            //     this.berkas.lembar_screenshoot_siak_ng = response5.data.data;

            //     updateBerkas(this.berkas)
            //     .then(response => {
            //       if (response.data.success == true) {
            //         // this.$toast({
            //         //   component: ToastificationContent,
            //         //   props: {
            //         //     title: 'Pengajuan Sidang',
            //         //     icon: 'EditIcon',
            //         //     variant: 'success',
            //         //     text: 'Data berhasil disimpan',
            //         //   },
            //         //   duration: 5000,
            //         // })
            //       } else {
            //         this.$toast({
            //           component: ToastificationContent,
            //           props: {
            //             title: 'Pengajuan Sidang',
            //             icon: 'EditIcon',
            //             variant: 'danger',
            //             text: response.data.message,
            //           },
            //         })
            //       }
            //     })
            //     .catch(error => console.log(error));
            //   })
            // .catch(error => console.log(error));
            // }
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            this.$bvModal.show('modal-center-loading')
            this.showModal = 1
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress2() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules2.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
